import styled from "styled-components";
import NEXT_SVG from "assets/images/next.svg";
import { MouseEventHandler } from "react";
import { hw } from "features/homework/homeworkUi";

interface CardHeaderProps {
    title: string;
    onNextClick?: MouseEventHandler;
    color?: string;
}

const CardHeader = ({ title, onNextClick, color }: CardHeaderProps) => {
    return (
        <Header>
            <Name $color={color}>{title}</Name>
            {onNextClick ? (
                <More type="button" onClick={onNextClick} aria-label={`${title} 더보기`}>
                    <img src={NEXT_SVG} alt="" />
                </More>
            ) : null}
        </Header>
    );
};

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;

const Name = styled.span<{ $color?: string }>`
    color: ${props => props.$color || hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

const More = styled.button`
    appearance: none;
    border: none;
    background: transparent;
    width: 28px;
    height: 28px;
    padding: 0;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    img {
        width: 16px;
        height: 16px;
        opacity: 0.45;
    }

    &:hover {
        background: ${hw.bg};
        img {
            opacity: 1;
        }
    }
`;

export default CardHeader;
